import { Container, Row, Col, Button, Form } from "react-bootstrap";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import green_tick from "../../../images/green_tick.png";
import tick from "../../../images/tick.png";
import cross_icon from "../../../images/red_cross.png";
import { useNavigate, useParams } from "react-router-dom";
import countriesData from "../../../data/countries.json";
import { useState, useRef, useEffect } from "react";
import countriesStateData from "../../../data/states.json";
import { toHaveFormValues } from "@testing-library/jest-dom/matchers";
import BackButton from "../../Includes/BackButtonEntityAccount";
import red_cross_icon from "../../../images/circle_cross.png";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import renderField from "../../renderField";
import { connect } from "react-redux";
import {
  setUploadDocumentDetails,
  setwizardPageNumber,
  setwizardPageName,
  setCheckPage,
  setUserID,
  setEntityAccountUserDetails,
  setEntityAccountBusinessDetails,
  setBusinessAddressDetails,
} from "../../EntityAccountReducer";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { ToastBox, notifyError } from "MyComponents/Toaster";
import SelfieCameraModal from "../../Camera/SelfieCameraModal";
import config from "../../../config";
import axios, { AxiosError } from "axios";
import { updateEntityKycDraftStep, uploadEntityKycDraftFiles } from "../../../Utils/entityKycDraft";
import MultiFileSelector from "./FilePicker";
import CustomMultiLineTextArea from "./CustomMultiLineTextArea";
import { useTranslation } from "react-i18next";

interface Props { }

interface FormData {
  physicalBusinessAddressDocumentInfo: string;
}

interface UploadedFile {
  filename: string;
  url: string;
}

const UploadDocumentForm: React.FC<
  Props & InjectedFormProps<{}, Props, FormData>
> = (props: any) => {
  const { handleSubmit } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const page = useSelector(
    (state: RootState) => state.entityAccount.wizardPageNumber
  );
  const email = useSelector((state: RootState) => state.entityAccount.email);
  const entityAccountBusinessDetails = useSelector(
    (state: RootState) => state.entityAccount.entityAccountBusinessDetails
  );
  const userIDFromRedux = useSelector((state: RootState) => state.entityAccount.userID);
  const { userId: userIdFromUrl } = useParams<{ userId?: string }>();
  const userID = userIDFromRedux || userIdFromUrl || "";
  const checkPage = useSelector((state: RootState) => state.entityAccount.checkPage);

  const [validated, setValidated] = useState(false);
  const [validated2, setValidated2] = useState(false);

  const [uploadedDocument, setUploadedDocument] = useState<UploadedFile[]>(props?.initialValues?.organizationalDocument || []);
  const [pendingFiles, setPendingFiles] = useState<File[]>([]);

  const [uploadedDocument2, setUploadedDocument2] = useState<UploadedFile[]>(
    props?.initialValues?.proofPhysicalBusinessAddress || []
  );
  const [pendingFiles2, setPendingFiles2] = useState<File[]>([]);

  const [physicalBusinessDescription, setPhysicalBusinessDescription] = useState(props?.initialValues?.physicalBusinessAddressDocumentInfo || "");
  const [descriptionError, setDescriptionError] = useState(false);

  useEffect(() => {
    dispatch(setwizardPageName("uploadedDocuments"));
  }, [dispatch]);

  useEffect(() => {
    if (uploadedDocument.length > 0 || pendingFiles.length > 0) {
      setValidated(false);
    }
  }, [uploadedDocument, pendingFiles]);

  useEffect(() => {
    if (uploadedDocument2.length > 0 || pendingFiles2.length > 0) {
      setValidated2(false);
    }
  }, [uploadedDocument2, pendingFiles2]);

  useEffect(() => {
    if (props.initialValues) {
      const vals = props.initialValues;
      if (vals.organizationalDocument) setUploadedDocument(vals.organizationalDocument);
      if (vals.proofPhysicalBusinessAddress) setUploadedDocument2(vals.proofPhysicalBusinessAddress);
      if (vals.physicalBusinessAddressDocumentInfo) {
        setPhysicalBusinessDescription(vals.physicalBusinessAddressDocumentInfo);
      }
    }
  }, [props.initialValues]);

  const validatePhysicalBusinessDocumentInfo = (value: any) => {
    if (!value) {
      return "Business document info required";
    }
  };

  const saveUploadDocumentsDetails = async (
    email: String,
    userID: string,
    organizationalDocument: UploadedFile[],
    proofPhysicalBusinessAddress: UploadedFile[],
    orgFiles?: File[],
    proofFiles?: File[]
  ) => {
    try {
      let updatedOrgDocs = [...organizationalDocument];
      let updatedProofDocs = [...proofPhysicalBusinessAddress];

      if (orgFiles && orgFiles.length > 0) {
        const uploadedOrg = await uploadEntityKycDraftFiles(userID, orgFiles);
        if (uploadedOrg) {
           updatedOrgDocs = [...updatedOrgDocs, ...uploadedOrg];
        }
      }

      if (proofFiles && proofFiles.length > 0) {
        const uploadedProof = await uploadEntityKycDraftFiles(userID, proofFiles);
        if (uploadedProof) {
           updatedProofDocs = [...updatedProofDocs, ...uploadedProof];
        }
      }

      const payload = {
        email,
        organizationalDocument: updatedOrgDocs,
        proofPhysicalBusinessAddress: updatedProofDocs,
        physicalBusinessAddressDocumentInfo: physicalBusinessDescription || ""
      };

      const response = await updateEntityKycDraftStep(userID, "uploadedDocuments", payload);

      return {
        data: {
          organizationalDocument: updatedOrgDocs,
          proofPhysicalBusinessAddress: updatedProofDocs,
          physicalBusinessAddressDocumentInfo: payload.physicalBusinessAddressDocumentInfo
        }
      };
    } catch (error: any) {
      console.error(error);
      notifyError("Failed to update documents draft");
      return null;
    }
  };

  const submitUploadDocumentForm = async (formValues: FormData) => {
    let isValid = true;

    if (uploadedDocument.length === 0 && pendingFiles.length === 0) {
      setValidated(true);
      isValid = false;
    }

    if (uploadedDocument2.length === 0 && pendingFiles2.length === 0) {
      setValidated2(true);
      isValid = false;
    }

    if (!physicalBusinessDescription) {
      setDescriptionError(true);
      isValid = false;
    }

    if (!isValid) return;

    const physicalBusinessAddressDocumentInfo = physicalBusinessDescription;

    const UploadDocumentDetailsObject = {
      organizationalDocument: uploadedDocument,
      proofPhysicalBusinessAddress: uploadedDocument2,
      physicalBusinessAddressDocumentInfo: physicalBusinessAddressDocumentInfo,
    };
    console.log("Upload Document Details: ", UploadDocumentDetailsObject);

    const Response = await saveUploadDocumentsDetails(
      email,
      userID,
      uploadedDocument,
      uploadedDocument2,
      pendingFiles,
      pendingFiles2
    );
    if (Response && Response.data) {
      dispatch(
        setUploadDocumentDetails({
          organizationalDocument: Response.data.organizationalDocument,
          proofPhysicalBusinessAddress: Response.data.proofPhysicalBusinessAddress,
          physicalBusinessAddressDocumentInfo: Response.data.physicalBusinessAddressDocumentInfo,
        })
      );
      // If we came from the summary page, return there instead of going to certification
      if (checkPage === 'SummaryPage') {
        dispatch(setCheckPage(''));
        dispatch(setwizardPageName("summary"));
        dispatch(setwizardPageNumber(7));
        localStorage.setItem("pageName", "summary");
        localStorage.setItem("pageNumber", "7");
      } else {
        dispatch(setwizardPageName("certification"));
        dispatch(setwizardPageNumber(6));
        localStorage.setItem("pageName", "certification");
        localStorage.setItem("pageNumber", "6");
      }
    }
  };

  return (
    <>
      <div className="pt-0 pb-3 mb-5 col-md-11 mx-auto px-2">
        <Row className="row justify-content-center">
          <Col md={11}>
            <p className=" fw-bold  d-inline">{t('kyc.entity_account_app')}</p>
            <p className="text-warning d-inline ms-3 small">{t('common.in_progress')}</p><br />
            <label className="mt-3 form-label  fw-bold ">{t('kyc.upload_documents_title')}</label>
            <p className="text-secondary small">
              {t('kyc.upload_docs_desc')}
            </p>
          </Col>
        </Row>
        <div className="row justify-content-center">
          <Col md={11}>
            <Form
              noValidate={true}
              onSubmit={handleSubmit(submitUploadDocumentForm)}
            >
              <Row className="mb-3 mt-4 row">
                <Col md={12}>
                  <label className="form-label  fw-bold   d-inline">
                    {t('kyc.org_docs')}
                  </label>
                  <p className="text-danger d-inline ms-3 small">*</p>

                  <div className="row justify-content-center  mt-2">
                    <p className="text-secondary small mt-2">
                      {t('kyc.org_docs_desc')} {t('kyc.org_docs_provide')}
                    </p>
                    <div className="col-md-4">
                      <p className="text-secondary small m-0">
                        <img src={green_tick} />
                        &nbsp;&nbsp;{t('kyc.org_docs_articles_inc')}
                      </p>
                    </div>
                    <div className="col-md-4">
                      <p className="text-secondary small m-0">
                        <img src={green_tick} />
                        &nbsp;&nbsp;{t('kyc.org_docs_articles_assoc')}
                      </p>
                    </div>
                    <div className="col-md-4">
                      <p className="text-secondary small m-0">
                        <img src={green_tick} />
                        &nbsp;&nbsp;{t('kyc.org_docs_trust')}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p className="text-secondary small m-0">
                        <img src={green_tick} />
                        &nbsp;&nbsp;{t('kyc.org_docs_govt_extract')}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p className="text-secondary small m-0 p-0">
                        <img src={green_tick} />
                        &nbsp;&nbsp;{t('kyc.org_docs_other_reg')}
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md={12} className="pb-1">
                  <MultiFileSelector
                    maxFiles={3}
                    maxFileSizeMB={20}
                    existedFiles={uploadedDocument}
                    onFilesChange={(files) => {
                      setUploadedDocument(files);
                    }}
                    onPendingFilesChange={(files) => {
                      setPendingFiles(files);
                    }}
                  />
                </Col>
                {validated && (
                  <p className="text-danger small mt-1 ps-2 mb-0 fw-bold">
                    {t('kyc.upload_org_required')}
                  </p>
                )}
              </Row>
              <Row className="mb-3 mt-4">
                <Col md={12}>
                  <label className="form-label  fw-bold  d-inline">
                    {t('kyc.proof_physical_business_label')}
                  </label>
                  <p className="text-danger d-inline ms-3 small">*</p>

                  <Row className="justify-content-center  mt-2 p-1">
                    <p className="text-secondary small mt-2">
                      {t('kyc.proof_physical_business_desc')}
                    </p>
                    <Col md={12}>
                      <p className="text-secondary small m-0">
                        <img src={green_tick} />
                        &nbsp;&nbsp;&nbsp;&nbsp;{t('kyc.proof_in_entity_name')}
                      </p>
                      <p className="text-secondary small m-0">
                        <img src={green_tick} />
                        &nbsp;&nbsp;&nbsp;&nbsp;{t('kyc.proof_matches_principal')}
                      </p>
                      <p className="text-secondary small m-0">
                        <img src={green_tick} />
                        &nbsp;&nbsp;&nbsp;&nbsp;{t('kyc.proof_dated_90_days')}
                      </p>
                      <p className="text-secondary small m-0">
                        <img src={green_tick} />
                        &nbsp;&nbsp;&nbsp;&nbsp;{t('kyc.proof_physical_not_po')}
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col md={12} className="pb-1">
                  <MultiFileSelector
                    maxFiles={3}
                    maxFileSizeMB={20}
                    existedFiles={uploadedDocument2}
                    onFilesChange={(files) => {
                      setUploadedDocument2(files);
                    }}
                    onPendingFilesChange={(files) => {
                      setPendingFiles2(files);
                    }}
                  />
                </Col>
                {validated2 && (
                  <p className="text-danger small mt-1 ps-2 mb-0 fw-bold">
                    {t('kyc.upload_proof_required2')}
                  </p>
                )}
              </Row>

              <Row className="mb-3 mt-4">
                <Col md={12}>
                  <label className="text-secondary small  ">
                    {t('kyc.additional_info_label')}
                  </label>
                  <Row>
                    <CustomMultiLineTextArea
                      initialValue={physicalBusinessDescription}
                      maxWords={2000}
                      onChange={(val) => {
                        setPhysicalBusinessDescription(val);
                        setDescriptionError(false);
                      }}
                      description=""
                    />
                    {descriptionError && (
                      <p className="text-danger fw-bold small text-start">
                        *Description is required.
                      </p>
                    )}
                  </Row>
                </Col>
              </Row>

              <Row className="mt-3 mb-2">
                <Col md={6} className="py-3">
                  <Button
                    type="submit"
                    className="btn btn-primary rounded-5  mt-2"
                  >
                    {t('common.save_continue')}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  initialValues: {
    organizationalDocument: state.entityAccount?.uploadDocumentDetails?.organizationalDocument || "",
    proofPhysicalBusinessAddress: state.entityAccount?.uploadDocumentDetails?.proofPhysicalBusinessAddress || "",
    physicalBusinessAddressDocumentInfo: state.entityAccount?.uploadDocumentDetails?.physicalBusinessAddressDocumentInfo || ""
  },
});

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  form: "uploadDocumentForm",
  enableReinitialize: true,
})(UploadDocumentForm);

export default connect(mapStateToProps)(form);
